import { IUseLoyaltyUserPromotions } from './types';

export const useLoyaltyUserPromotions: IUseLoyaltyUserPromotions = () => ({
  availablePromotionsMap: {},
});
